const randomNo = ceiling => Math.floor(Math.random() * (ceiling + 1))
export default randomNo